import { useInitDataStore } from '@/stores/initDataStore'

type Attrs = {
  id: string
  name: string
}

export default class Area {
  public id: string
  public name: string

  constructor({ id, name }: Attrs) {
    this.id = id
    this.name = name
  }

  stations() {
    const initDataStore = useInitDataStore()

    return initDataStore.initData.stationList.filter(station => {
      return station.areaCode.includes(this.id)
    })
  }
}
